<template>
  <div>
    <rabbey-toolbox
      :call-new="addNew"
      :filterables="true"
      @filter-search="onFilterSearch"
    />

    <rabbey-table3
      :loading="loading"
      :data="itemsFilter"
      :columns="columns"
      :actions="actions"
      @rtable-push-action="handleCommand"
    ></rabbey-table3>

    <DrawerUserView
      :disable-input="isView"
      :drawer.sync="drawer"
      :disableInput="isNew || isEdit ? false : true"
      :isEdit="isEdit"
      :isNew="isNew"
      :model-data.sync="modelData"
      @submit-response="onSubmitResponse"
      @updateDrawerClose="handleDrawerClose"
    />
  </div>
</template>

<script>
import DrawerUserView from "@/components/user_manager/DrawerUserView.vue";
import RenderCheckVue from "@/components/functionals/RenderCheck.vue";
import { filterItems } from "@/utils";

export default {
  name: "UserManager",
  components: {
    DrawerUserView
  },
  data() {
    return {
      search: "",
      loading: false,
      isView: false,
      isEdit: false,
      isNew: false,
      drawer: false,
      modelData: {},
      items: [],
      columns: [
        {
          label: "NO",
          prop: "Id",
          width: 80,
          fixed: true,
          sortable: true
        },
        {
          label: "Nombre",
          prop: "FullName"
        },
        {
          label: "N. usuario",
          prop: "UserName"
        },
        {
          label: "Activo",
          prop: "IsEnabled",
          formatter: RenderCheckVue,
          width: 100,
          sortable: true
        },
        {
          label: "Email",
          prop: "Email"
        }
      ],
      actions: [
        {
          label: "Ver",
          command: "view",
          icon: "el-icon-view"
        },
        {
          label: "Editar",
          command: "edit",
          icon: "el-icon-edit"
        },
        {
          label: "Desactivar Usuario",
          command: "disable",
          icon: "el-icon-close",
          condition: (row) => row.IsEnabled === true
        },
        {
          label: "Activar Usuario",
          command: "enable",
          icon: "el-icon-check",
          condition: (row) => row.IsEnabled === false
        }
      ]
    };
  },
  async created() {
    // buscar los usuarios
    await this.fetchItems();
  },
  computed: {
    itemsReverse() {
      const items = this.items;
      if (items.length === 0) return [];
      return items.reverse();
    },
    itemsFilter() {
      const filter = filterItems(this.search, this.items);
      return filter;
    }
  },
  methods: {
    onFilterSearch(data) {
      //this.fetchItems(search);
      this.search = data;
    },
    async fetchItems() {
      try {
        this.loading = true;
        const response = await this.$http.get("/api/users");
        const { data } = response;
        data.reverse();
        this.items = data;
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
    handleCommand(action) {
      switch (action.command) {
        case "view": {
          this.isView = true;
          this.modelData = { ...action.row };
          this.drawer = true;
          break;
        }
        case "edit": {
          this.isView = true;
          this.isEdit = true;
          this.modelData = { ...action.row };
          this.drawer = true;
          break;
        }
        case "disable": {
          this.disableUser(action.row.Id);
          break;
        }
        case "enable": {
          this.enableUser(action.row.Id);
          break;
        }
        default: {
          break;
        }
      }
    },
    addNew() {
      this.isNew = true;
      this.isView = false;
      this.isEdit = false;
      this.modelData = {};
      this.drawer = true;
    },
    async onSubmitResponse(status) {
      this.isEdit = false;
      this.isNew = false;
      this.modelData = null;
      if (status === "success") {
        await this.fetchItems();
        this.drawer = false;
      } else if (status === "error") {
        await this.fetchItems();
      }
    },
    async disableUser(userId) {
      await this.$_helperEnableAndDisableUser(
        "/api/users/disable",
        userId,
        false
      );
    },
    async enableUser(userId) {
      await this.$_helperEnableAndDisableUser(
        "/api/users/enable",
        userId,
        true
      );
    },
    async $_helperEnableAndDisableUser(url, userId, isEnabled) {
      try {
        const response = await this.$http.post(
          url,
          {},
          {
            timeout: 3 * 60 * 1000,
            params: {
              user: userId
            }
          }
        );

        // logica de update de user en el frontend
        this.loading = true;
        const user = this.items.find((f) => f.Id === userId);

        if (response && user) {
          user.IsEnabled = isEnabled;
        } else {
          this.$message.error("Ocurrio error revise la API");
        }
        this.loading = false;
      } catch (err) {
        console.error(err);
      }
    },
    handleDrawerClose() {
      this.drawer = false;
      this.isEdit = false;
      this.isNew = false;
    }
  }
};
</script>
